import { ChangeDetectionStrategy, Component, Input, WritableSignal } from '@angular/core';
import { CloseDangerSvgIconComponent } from '@components/svg-icons/close-danger-svg-icon/close-danger-svg-icon.component';

@Component({
  selector: 'ln-unsuccessful-order-response-card',
  imports: [CloseDangerSvgIconComponent],
  templateUrl: './unsuccessful-order-response-card.component.html',
  styleUrl: './unsuccessful-order-response-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsuccessfulOrderResponseCardComponent {
  @Input({ required: true }) text!: string;
  @Input({ required: true }) present!: WritableSignal<boolean>;
  closeButton() {
    this.present.set(false);
  }
}
